
export const contractsData = {
  basic: {
    accountType: 'basic',
    name: 'Basic',
    features: [
      'Annonce med kontaktformular',
      'Få henvendelser via e-mail & SMS',
      'Stor synlighed overfor potentielle lejere',
      'Personlig hjælp og support via telefon, e-mail og chat',
      'Ingen binding. Du kan altid skifte afregningsmodel',
      'Upload video til din annonce',
    ],
    prices: {
      month: {
        price: '199 kr. / mdr.',
      },
      year: {
        discountPrice: '199 kr.',
        price: '83 kr. / mdr.',
        undiscountedPrice: '(999 kr. / 12 mdr.)',
      }
    },
  },

  basic_plus: {
    accountType: 'basic_plus',
    inquiriesIncrease: '100',
    name: 'Basic Plus',
    features: [
      'Annonce med kontaktformular',
      'Få henvendelser via e-mail & SMS',
      'Stor synlighed overfor potentielle lejere',
      'Personlig hjælp og support via telefon, e-mail og chat',
      'Ingen binding. Du kan altid skifte afregningsmodel',
      'Upload video til din annonce',
      '<strong>Synlig e-mail & telefonnummer</strong>, så lejer kan skrive eller ringe direkte (giver ca. 100% flere henvendelser)',
      'Link til egen hjemmeside. Få mere trafik og henvendelser',
      'Visning af logo for branding',
      'Billede af kontaktperson',
    ],
    prices: {
      month: {
        price: '749 kr. / mdr.',
      },
      year: {
        discountPrice: '749 kr.',
        price: '208 kr. / mdr.',
        undiscountedPrice: '(2.499 kr. / 12 mdr.)',
      }
    },
  },

  premium: {
    accountType: 'premium',
    inquiriesIncrease: '150',
    name: 'Premium',
    features: [
      'Annonce med kontaktformular',
      'Få henvendelser via e-mail & SMS',
      'Stor synlighed overfor potentielle lejere',
      'Personlig hjælp og support via telefon, e-mail og chat',
      'Ingen binding. Du kan altid skifte afregningsmodel',
      'Upload video til din annonce',
      '<strong>Synlig e-mail & telefonnummer</strong>, så lejer kan skrive eller ringe direkte (giver ca. 100% flere henvendelser)',
      'Link til egen hjemmeside. Få mere trafik og henvendelser',
      'Visning af logo for branding',
      'Billede af kontaktperson',
      '<strong>Stor, fremhævet annonce</strong>&nbsp; for maks. Eksponering og synlighed (Normalpris: 699 kr.)',
      'Løbende &nbsp;<strong>Facebook kampagner</strong>&nbsp; på lejemål (Normalpris: 699 kr.)',
    ],
    prices: {
      month: {
        price: '1.499 kr. / mdr.',
      },
      year: {
        discountPrice: '1.449 kr.',
        price: '999 kr. / mdr.',
        undiscountedPrice: '(11.988 kr. / 12 mdr.)',
      }
    },
  },
};
